<template>
  <button class="btn" @click="$emit('click')"><slot></slot></button>
</template>

<script>
export default {
  name: 'BaseButton',
};
</script>

<style scoped>
  .btn {
    background: #2187c6;
    border: 0;
    outline: 0;
    color: #FFFFFF;
    font-size: 18px;
    border-radius: 45px;
    padding: 0 25px;
    line-height: 44px;
  }
  .btn-block {
    width: 100%;
  }
  .btn:disabled {
    opacity: 0.6;
    background: gray;
    cursor: not-allowed;
  }
  .btn-warning {
    background: #f0ad4e;
  }
  .btn-danger {
    background: #d9534f;
  }
  .btn-default {
    background: #FFFFFF;
    color: #333333;
    border: 1px solid #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/components/Button.vue